module.exports = "/images/vendor/flag-icon-css/flags/1x1/et.svg?1d986679c4676b25570d4ee8719a41de";